import { render, staticRenderFns } from "./OrderStateCrud.vue?vue&type=template&id=1c71c0d5"
import script from "./OrderStateCrud.vue?vue&type=script&lang=js"
export * from "./OrderStateCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports